import type { Role } from '@kanbu/schema/enums';

import { useUser } from './useUser';

export function useAccess() {
  const { user } = useUser();

  return {
    hasAccess: (roles: Role[]) => user?.role && roles.includes(user?.role),
  };
}
